import {LitElement, html, css, svg} from 'lit';
import {customElement, property} from 'lit/decorators.js';

@customElement('obi-current-2')
export class ObiCurrent2 extends LitElement {
  @property({type: Boolean}) useCssColor = false;

  private icon = svg`<svg width="24" height="25" viewBox="0 0 24 25" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M10.9743 12.0003L10.9743 24.0049L12.9999 24.005L12.9999 12.0004L10.9743 12.0003Z" fill="currentColor"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M6.79291 5.20747L12 0.000366211L17.2071 5.20747L15.7929 6.62169L12 2.82879L8.20712 6.62169L6.79291 5.20747Z" fill="currentColor"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M6.99994 10.5861L12.207 5.37903L17.4142 10.5861L15.9999 12.0003L12.207 8.20745L8.41415 12.0003L6.99994 10.5861Z" fill="currentColor"/>
</svg>
`;

  private iconCss = svg`<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.9743 12.0003L10.9743 24.0049L12.9999 24.005L12.9999 12.0004L10.9743 12.0003Z" style="fill: var(--element-active-color)"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M6.79291 5.20747L12 0.000366211L17.2071 5.20747L15.7929 6.62169L12 2.82879L8.20712 6.62169L6.79291 5.20747Z" style="fill: var(--element-active-color)"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M6.99994 10.5861L12.207 5.37903L17.4142 10.5861L15.9999 12.0003L12.207 8.20745L8.41415 12.0003L6.99994 10.5861Z" style="fill: var(--element-active-color)"/>
</svg>
`;

  override render() {
    return html`
      <div class="wrapper">${this.useCssColor ? this.iconCss : this.icon}</div>
    `;
  }

  static override styles = css`
    .wrapper {
      height: 100%;
      width: 100%;
      line-height: 0;
    }
    .wrapper > * {
      height: 100%;
      width: 100%;
    }
  `;
}

declare global {
  interface HTMLElementTagNameMap {
    'obi-current-2': ObiCurrent2;
  }
}
